/**
 * 判断一个值是否是有效的值, 即不是 null, undefined, '' 中的任何一个
 * @param {*}} value
 * @returns Boolean
 */
export function isValidValue(value) {
  return value
    ? true
    : !![0, false].includes(value);
}

export default function merge(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    const source = arguments[i] || {};
    for (const prop in source) {
      // if (source.hasOwnProperty(prop)) {
      if (Object.prototype.hasOwnProperty.call(source, prop)) {
        const value = source[prop];

        if (isValidValue(value)) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
}
